import { MaintenancePlanItem } from "./maintenancePlanItem.model";

export class MaintenancePlan {
    public id: number;
    public name: string;
    public description: string;
    public version: number;
    public maintenancePlanItems: MaintenancePlanItem[];
    public nrOfTools: number;
    public nrOfTasks: number;
    public nrOfActivities: number;
    public tools: any[];

    constructor(plan: any = {}) {
        this.id = plan.id || 0;
        this.name = plan.name || '';
        this.description = plan.description || '';
        this.version = plan.version || 0;
        this.nrOfTasks = plan.nrOfTasks || 0;
        this.nrOfTools = plan.nrOfTools || 0;
        this.nrOfActivities = plan.nrOfActivities || plan.nrOfOperations || 0;
        this.maintenancePlanItems = plan.maintenancePlanItems || [];
        this.tools = plan.tools || [];
    }

    get type() {
        return 'maintenancePlan';
    }
}
